<template>
  <div class="block_wrap">
    <div class="response_table role_table">
      <table>
        <thead style="flex:0;">
          <tr>
            <th scope="col"> Roles </th>
            <th scope="col"> Descriptions </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(role, role_key) in role_list" :key="role_key" class="role">
            <td data-label="Name">
              <span>{{ role.name }}</span>
            </td>

            <td data-label="Description" class="description">
              <span>{{ role.description }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="response_table permission_table">
      <table>
        <thead style="flex:0;">
        <tr>
          <th scope="col"> Permissions </th>
          <th scope="col"> Descriptions </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(permission, permission_key) in permission_list" :key="permission_key" class="permission">
          <td data-label="Name">
            <span>{{ permission.name }}</span>
          </td>

          <td data-label="Description" class="description">
            <span>{{ permission.description }}</span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>

export default {
  name: "RoleManagement",
  props: ['roles_and_permissions'],
  data () {
    return {
      pwd: true,
      disabled_btn: false,
      old_url: '',
      user_roles: []
    }
  },
  computed:{
    role_list(){
      return this.roles_and_permissions.roles
    },
    permission_list(){
      return this.roles_and_permissions.permissions
    },
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
  }
}

</script>
<style lang='scss' scoped>
  .block_wrap{
    height: 100%;
    overflow-y: scroll;
    .response_table{
      height: auto;
      margin-bottom: 1px;
    }
  }
  .role_table{
    table{
      tbody{
        .role{
          .permissions{
            max-height: 150px;
            display: block;
            overflow-y: scroll;
          }
          .action{
            font-size: 14px;
            line-height: 100%;
            cursor: pointer;
            padding: 2px;
          }
        }
      }
    }
  }



</style>
